import { IaIcon, Text } from '@viapeople/components'

export function IntegrationCard({
	title,
	description,
	configured,
	onClick,
}: {
	title: string
	description: string
	configured: boolean
	onClick: () => void
}) {
	return (
		<button
			type='button'
			className='bg-white rounded-lg shadow-sm border border-neutral-200 p-6 cursor-pointer hover:shadow-md transition-shadow'
			onClick={onClick}>
			<div className='flex items-center justify-center mb-4 relative'>
				<div className='p-3 bg-primary-50 rounded-lg'>
					<IaIcon className='w-6 h-6 text-primary-600' />
				</div>
				{configured && (
					<div className='absolute top-0 right-0 px-2 py-1 bg-success-50 text-success-700 text-xs font-medium rounded'>
						Configured
					</div>
				)}
			</div>

			<Text variant='medium' weight='semibold' className='mb-2'>
				{title}
			</Text>

			<Text variant='small' className='text-neutral-600'>
				{description}
			</Text>
		</button>
	)
}
